/* eslint-disable */
import qFetch from '@/utils/qFetch'

// 初始化时查询各红包信息
export function queryRedPacketStatus(activityIdList = []) {
  const url = '/bnbapp-node-cq/app/promotion/redpacket/searchactivitybyactivityidlist'
  const ajaxData = {
    activityIdList
  }
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: {
      parameter: ajaxData
    },

    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}

// 领红包
export function receiveRedPacket(redpacketIds, requereRedPacketInfo) {
  const url = '/bnbapp-node-cq/app/promotion/redpacket/sendcouponbatch/bnb'
  const ajaxData = {
    parameter: {
      sendCouponBatchs: redpacketIds,
      requereRedPacketInfo
    }
  }

  return qFetch({
    url: '/tjbnb/app/common/login',
    data: ajaxData,
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}

// 查询活动裂变
export function fetchRedpacketFission(activityIdList = []) {
  const url = '/bnbapp-node-cq/app/promotion/redpacket/queryfissionactivitybyactivityidlist'
  const ajaxData = {
    activityIdList
  }
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: {
      parameter: ajaxData
    },

    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}

// 裂变活动领券
export function doRedpacketFission(redpacketIds, requereRedPacketInfo, ownerMemberId = '') {
  const url = '/bnbapp-node-cq/app/promotion/redpacket/sendfissioncoupon/bnb'
  const ajaxData = {
    parameter: {
      sendCouponBatchs: redpacketIds,
      requereRedPacketInfo,
      ownerMemberId
    }
  }

  return qFetch({
    url: '/tjbnb/app/common/login',
    data: ajaxData,
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}

export function queryQunarRedpack(qunarCouponParamList = []) {
  const ajaxData = {
    qunarCouponParamList
  }
  return qFetch({
    url: '/tjbnb/app/coupon/qunarcoupon/check',
    data: ajaxData,
  }).then((res) => {
    return Promise.resolve(res)
  })
}

export function receiveQunarRedpack(qunarCouponParamList = []) {
  const ajaxData = {
    qunarCouponParamList
  }
  return qFetch({
    url: '/tjbnb/app/coupon/qunarcoupon/get',
    data: ajaxData,
  }).then((res) => {
    return Promise.resolve(res)
  })
}